/* eslint-disable */
import React, { useState } from 'react'
import cn from 'classnames'
import { css, StyleSheet } from 'aphrodite'
import { checkPermission as cp } from '../utils/auth'
import { useDeleteRequest } from '../hooks/request'
import { CUSTOMER_DETAIL } from '../urls'
import { useMessage } from '../hooks/message'
import { useModal } from '../hooks/modal'
import CustomerUpdate from './CustomerUpdate'
import TelegramInvite from './TelegramInvite'

export default function CustomerActions({ onDelete, customer, onUpdate }) {
    const customerDelete = useDeleteRequest({ url: CUSTOMER_DETAIL.replace('{id}', customer.id) })
    const [showDropdown, setShowDropdown] = useState(false)
    const [showMessage] = useMessage()

    const [showUpdateModal, hideUpdateModal] = useModal(
        <CustomerUpdate customer={customer} onCancel={() => hideUpdateModal()} onSuccess={async () => {
            await onUpdate()
            hideUpdateModal()
        }} />,
    )

    const [showTelegramInviteModal, hideTelegramInviteModal] = useModal(
        <TelegramInvite itemId={customer.id} onCancel={() => hideTelegramInviteModal()} userType="customer" />,
    )

    async function deleteCustomer() {
        if (!global.confirm('Вы действительно хотите удалить?')) return

        const { error } = await customerDelete.request()

        if (error) {
            showMessage(error.data.detail, 'is-danger')
            return
        }

        onDelete()
    }

    return (
        <div onMouseLeave={() => setShowDropdown(false)}
            onClick={(event) => event.stopPropagation()}
            className={cn(
                'dropdown is-right is-pulled-right',
                { 'is-active': showDropdown },
                css(styles.more),
            )}>

            <div className="dropdown-trigger">
                <button className={cn('button is-white', css(styles.button))}
                    onClick={() => setShowDropdown(!showDropdown)}>
                    <i className="icon ion-md-more" />
                </button>
            </div>

            <div className="dropdown-menu">
                <div className="dropdown-content">
                    {cp('project.change_customer') ? (
                        <a className="dropdown-item" onClick={showUpdateModal}>
                            <i className="icon ion-md-create" />
                            Изменить
                        </a>
                    ) : null}

                    {cp('project.delete_customer') ? (
                        <a className="dropdown-item" onClick={deleteCustomer}>
                            <i className="icon ion-md-trash" />
                            Удалить
                        </a>
                    ) : null}

                    {cp('telegram.add_telegraminvitation') ? (
                        <a className="dropdown-item" onClick={showTelegramInviteModal}>
                            <i className="icon ion-md-link" />
                            Пригласить в телеграмм
                        </a>
                    ) : null}
                </div>
            </div>
        </div>
    )
}

const styles = StyleSheet.create({
    button: {
        backgroundColor: 'transparent',
        ':hover': { backgroundColor: '#fcfcfc' },
    },
    more: {
        bottom: '0',
        left: '1rem',
    },
})
